import React from 'react'
import AdminNavbar from '../Navbar/AdminNavbar'
import { Button, Input, Select, Spin, Table, Tooltip } from "antd";
import { AiFillAccountBook } from "react-icons/ai";
import axios from 'axios';
import { useState,useEffect } from 'react';
import { MineMasterAdd, MineMasterBlock, MineMasterDelete, MineMasterFindAll, MineMasterUpdate } from '../Api/All_Api';
import { toast } from "react-toastify";
import { Option } from 'antd/es/mentions';
import { useNavigate } from 'react-router-dom';
import TitleNavbar from '../Navbar/TitleNavbar';

const MineMaster = () => {
  const role = sessionStorage.getItem('role');
  const branchId = sessionStorage.getItem('branchId');

    const sessionYear = sessionStorage.getItem('sessionYear');
  const navigate = useNavigate();
      useEffect(() => {
        if (!sessionYear) {
          sessionStorage.clear();
          navigate('/')
        }
      },[])

  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [products, setProducts] = useState([]);
  const [alldata, setAllData] = useState([]);

  const [errors, setErrors] = useState({
    mineName: '', 
    mineAddress:'',

  });


const [filteredData, setFilteredData] = useState([]);

const[allMine , setAllMine]=useState([]);
const [mineName, setMineName] = useState('');
const [isAssigned, setIsAssigned] = useState('');
const [mineAddress, setMineAddress] = useState('');
const [mineId, setMineId] = useState('');
const [loading, setLoading] = useState(false);
const [updateButton, setUpdateButton] = useState(false);
const [saveButton, setSaveButton] = useState(true);

const handleSearch = (value) => {
  const filtered = allMine.filter((item) =>
    Object.values(item).some((val) =>
      val?.toString().toLowerCase().includes(value.toLowerCase())
    )
  );
  setFilteredData(filtered);
  setTotalEntries(filtered.length); // Update total entries count after filtering
  setCurrentPage(1);
};
//==========Pagination=======================
const handlePageSizeChange = (value) => {
  setPageSize(value);
};

  const handleCancel = () => {
    setUpdateButton(false);
    setSaveButton(true);
 fetchMine();
    setMineAddress('');
    setMineName('');
    setErrors('');
  };

  useEffect(() => {
    fetchMine();
   
  }, []);
  // ========Submit data to table==============
  const handleSubmit = async () => {
    let isValid=true;
    const errorObj = {};
    if (!mineName) {
      isValid = false;
      errorObj.mineName = "Mine is required *";
    }
    if (!mineAddress) {
      isValid = false;
      errorObj.mineAddress = "Adress is required *";
    }
  
    setErrors(errorObj); // Set error messages

    if (!isValid) return;
    setLoading(true);
    const bodyData ={
    mineName : mineName,
    mineAddress : mineAddress,
    branchId:parseInt(branchId),
   
     
    }

    try {
      const response = await axios.post(MineMasterAdd,bodyData );

      if (response.data === "CREATED") {
        toast.success('Mine added successfully!');
        fetchMine();
        handleCancel();
      }
      else if (response.data === "ALREADYEXISTS") {
        toast.warn('Mine already exist!');
        handleCancel();
      }
    } catch (error) {
      console.error('Error during API call:', error);
      toast.error('Error occurred while submitting data');
    }
    finally{
      setLoading(false);
    }
  };

  // ========Update data from table============
  const handleEditDataButton = (item) => {
    setUpdateButton(true);
    setSaveButton(false);
    window.scrollTo(0, 0);
    setMineName(item.mineName);
    setMineId(item.id);
    setMineAddress(item.mineAddress);
    

  };
  let isError = false;
  const fetchMine = async () => {
    try {
        let bId= parseInt(branchId);
      const response = await axios.get(`${MineMasterFindAll}?branchId=${bId}`);
      if (response.data !== null) {
        setAllMine(response.data);
        setFilteredData(response.data); // Set initial filtered data as the fetched data
        setTotalEntries(response.data.length); // Set the total number of entries
      }
      
    } catch (error) {
        if (!isError) {  // Check if the error has already been triggered
          console.error('Error fetching Mine:', error);
          toast.error('Failed to fetch mine data');
          isError = true;  // Set the flag to prevent double toast
        }
    }
  };   
  const handleUpdate = async () => {
    let isValid=true;
    const errorObj = {};
    if (!mineName) {
      isValid = false;
      errorObj.mineName = "Mine is required *";
    }
    if (!mineAddress) {
      isValid = false;
      errorObj.mineAddress = "Adress is required *";
    }
  
    setErrors(errorObj); // Set error messages

    setLoading(true);
    const bodyData ={
      id: mineId,
     mineName : mineName,
     mineAddress : mineAddress,
    
   
    }

    try {
      const response = await axios.put(MineMasterUpdate,bodyData );

      if (response.data === "UPDATED") {
        toast.success(' Updated successfully!');
        fetchMine();
        handleCancel();
      }
      else if (response.data === "ALREADYEXISTS") {
              toast.warn('Mine already exist!');
              handleCancel();
            }
    } catch (error) {
      console.error('Error during API call:', error);
      toast.error('Error occurred while updating data');
    }
    finally{
      setLoading(false);
    }
  };

  // // ========Delete data from table============
  // const handleDeleteData = async (item) => {
  //     const confirmDelete = window.confirm(`Are you sure you want to delete ?`);
  //     if (!confirmDelete) return;

  //     try {
  //       const response = await axios.delete(`${MineMasterDelete}?id=${item.id}`);
  //       if (response.data === "DELETED") {
  //         toast.success('Mine deleted successfully!');
  //         fetchMine();
  //         handleCancel();
  //       }
  //     } catch (error) {
  //       console.error('Error during delete operation:', error);
  //       toast.error('Error occurred while deleting the stream');
  //     }
  // };
  const toggleBlockStatus = async (item) => {
    const confirmDelete = window.confirm(`Are you sure you want to  ${item.mineStatus == 1 ? 'activate' : 'block'} ${item.mineName}?`);
    if (!confirmDelete) return;
    try {
     
      const updatedActiveStatus = item.mineStatus == 1 ? 0 : 1;
      

      const response = await axios.put(`${MineMasterBlock}?id=${item.id}&block=${updatedActiveStatus}` );
  
      if (response.data === "BLOCKED" || response.data === "UNBLOCKED") {
      
        setAllMine(
          allMine.map((c) =>
            c.id === item.id ? { ...c, status: updatedActiveStatus } : c
          )
        );
  
        fetchMine();
        toast.success(`Mine ${updatedActiveStatus === 1 ? 'blocked' : 'unblocked'} successfully!`);
      } else {
        
        toast.error('Failed to update block status.');
      }
    } catch (error) {
      // Catch errors and display a toast message
      toast.error('Error updating block status!');
      console.error('Axios error:', error);
    }
  };

  const columns = [
    {
      title: "Sr.No.",
      dataIndex: "",
      key: "index",
      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: "Mine Name",
      dataIndex: "mineName",
      key: "mineName",
    },
    {
      title: "Mine Address",
      dataIndex: "mineAddress",
      key: "mineAddress",
    },
    {
      title: "Mine Status",
      dataIndex: "mineStatus",
      key: "mineStatus",
      key: "mineStatus",
      render: (text) => (
       <span
       style={{
         display: "inline-block",
         padding: "2px 10px",
         color: "white",
         borderRadius: "4px",
         backgroundColor: text == "1" ? "red" : "green",
       }}
     >
       {text == "1" ? "Blocked" : "Active"}
     </span>
      ),
    },
    {
      title: "Edit",
      key: "edit",
      width:"60px",
      render: (text, record) => (
        <div className='text-center'>
          <span   className='me-1 me-lg-2'
            type="submit"
            style={{ fontSize: "12px", color: "orange"}}
            onClick={() => handleEditDataButton(record)}
          >
         <Tooltip title="Edit">  <i class="fa-solid fa-pen-to-square"></i></Tooltip> 
          </span>
          {/* <span
            type="submit"
            style={{ fontSize: "12px", color: "blue", marginLeft: "10px" }}
            onClick={() => handleDeleteData(record)}
          >
            <i class="fa-solid fa-trash"></i>
          </span> */}
        </div>
      ),
    },
    {
      title: " Block",
      key: "block",
      width:"60px",
      render: (text, record) => (
        <div className='text-center'>
  
          <span 
          className='me-1 me-lg-2'
          type="button"
          style={{
            fontSize: "12px", 
            color: record.mineStatus === 1 ? "red" : "green", 
           
            cursor: "pointer"
          }}
          onClick={() => toggleBlockStatus(record)} 
        >
         <Tooltip title={record.mineStatus === 1 ? "Blocked":"Active" }>   <i className={`fa-solid ${record.mineStatus == 1 ? 'fa-lock' : 'fa-unlock'}`}></i> </Tooltip>
        </span>
        </div>
      ),
    },
  ];

  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: "#000",
            color: "#fff",
            padding: "10px",
            fontSize: "13px",
            borderRadius: "0px",
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: "#f0f7fd",
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: "8px",
          }}
        >
          {children}
        </td>
      ),
    },
  };

  //===================================
const navbg = {
  backgroundColor:"#f79400",
  boxShadow: "0 2px 4px -2px rgba(0,0,0,.5)",
  display: "flex",
  alignItems: "center",
  padding: "5px 10px",
  fontSize: "19px",
  color:"#fff"
}
//=====================================================

  return (
  <>
   
      <AdminNavbar />
   
    <div className="p-0 m-0" >
        {/* Header Section */}
        <div
          className="row m-0"
          style={navbg}
        >
          <div
            className="col-12"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
            }}
          >
            <span className="px-md-5" style={{ flexGrow: 1 }}>
      <AiFillAccountBook  />&nbsp;
     Mine Master
    </span>

    {/* TitleNavbar (Right-aligned) */}
    <span>
      <TitleNavbar />
    </span>
          </div>
        </div>

        {/* Form Section */}
        <div className='row m-0 p-0 pt-5'>
          <div className='col-12 col-lg-3'></div>
          <div className='col-12 col-lg-6'>
              <div className="row px-md-5 mt-3  m-0">

                <div className="col-12 pt-2">
                  <div className="row m-0">
                    <div className="col-3 p-0 lableStyle">
                <label className="labels"  style={{fontSize:16}}>Mine Name:</label>
              </div>
              <div className="col-9 col-lg-6" >
                <Input placeholder="Enter Name"
                 value={mineName} 
                      onChange={(e) => setMineName(e.target.value)}
                />  {errors.mineName && (
                          <div className="errorField">{errors.mineName}</div>
                        )}
              
              </div>
            </div>
          </div>

          <div className="col-12 pt-2">
                  <div className="row m-0">
                    <div className="col-3 p-0 lableStyle">
                <label className="labels"  style={{fontSize:16}}>Mine Address:</label>
              </div>
              <div className="col-9 col-lg-6">
                <Input placeholder="Enter Address" 
                      value={mineAddress}
                      onChange={(e) => setMineAddress(e.target.value)}
                />  {errors.mineAddress && (
                          <div className="errorField">{errors.mineAddress}</div>
                        )}
              </div>
            </div>
          </div>
          

          <div className="col-12 text-center pt-3">
            <Button type="button" onClick={handleCancel} className="CancelBtn mx-1">
              Cancel
            </Button>
             {saveButton && ( <Button
                type="button"
                className="SubmitBtn mx-1"
              
                onClick={handleSubmit}
                disabled={loading} // Disable button while loading
      >
        {loading ? <Spin size="small" /> : 'Save'}
              </Button>)}
             {updateButton&&( <Button
                type="button"
                className="UpdateBtn mx-1"
                
                onClick={handleUpdate}
                disabled={loading} // Disable button while loading
      >
        {loading ? <Spin size="small" /> : 'Update'}
              </Button>)}
          </div>

          <div
            className="col-12 p-0 mt-3"
            style={{ borderBottom: "2px solid #bfb597" }}
          ></div>
        </div>
        </div>
        <div className='col-12 col-md-2 col-lg-4'></div>
        </div>

     {/*================ Table =========================*/}
            <div className="row m-0 p-2 mb-5  pt-md-0 mt-3">
            <div className='col-12 col-md-2'></div>
              <div  className="col-12 col-md-8 py-3 shadow border"
                style={{ marginBottom: "50px", backgroundColor: "white" }}
              >
                <div
                  className="col-12 px-md-5"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                    <Select
                      defaultValue={pageSize}
                      onChange={handlePageSizeChange}
                      style={{ width: 120, textAlign: "center" }}
                    >
                      <Option value={10}>10</Option>
                      <Option value={20}>20</Option>
                      <Option value={30}>30</Option>
                    </Select>
                  </div>
    
                  <div className="pt-4 pt-md-0">
                    <Input.Search
                      placeholder="Search"
                      onSearch={handleSearch}
                      style={{ width: 200, marginBottom: 16 }}
                    />
                  </div>
                </div>
    
                <div style={{ backgroundColor: "white" }}>
                  <Table
                    bordered
                    style={{ padding: "0px 20px", overflowX: "auto" }}
                    columns={columns}
                    dataSource={filteredData}
                    pagination={{
                      pageSize: pageSize,
                      total: totalEntries,
                      showTotal: (total, range) =>
                        `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                      current: currentPage,
                      onChange: (page) => setCurrentPage(page),
                    }}
                    showSorterTooltip={false}
                    rowKey={(record) => record.id}
                    components={components}
                  />
                </div>
              </div>
              <div className='col-12 col-md-2'></div>
            </div>
      </div>
  </>
  )
}

export default MineMaster